import _objectSpread from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _slicedToArray from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "debug", "capsuleHalfHeight", "capsuleRadius", "floatHeight", "characterInitDir", "followLight", "camInitDis", "camMaxDis", "camMinDis", "camInitDir", "maxVelLimit", "turnVelMultiplier", "turnSpeed", "sprintMult", "jumpVel", "jumpForceToGroundMult", "slopJumpMult", "sprintJumpMult", "airDragMultiplier", "dragDampingC", "accDeltaTime", "rejectVelMult", "moveImpulsePointY", "camFollowMult", "rayOriginOffest", "rayHitForgiveness", "rayLength", "rayDir", "floatingDis", "springK", "dampingC", "showSlopeRayOrigin", "slopeMaxAngle", "slopeRayOriginOffest", "slopeRayLength", "slopeRayDir", "slopeUpExtraForce", "slopeDownExtraForce", "autoBalance", "autoBalanceSpringK", "autoBalanceDampingC", "autoBalanceSpringOnY", "autoBalanceDampingOnY", "animated"];
import { jsx, jsxs } from "react/jsx-runtime";
import { useGLTF, useAnimations, useKeyboardControls } from "@react-three/drei";
import { useThree, useFrame } from "@react-three/fiber";
import { useRapier, RigidBody, CapsuleCollider, quat } from "@react-three/rapier";
import { useMemo, useEffect, useRef, Suspense, forwardRef } from "react";
import * as THREE from "three";
import { useControls } from "leva";
import { create } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
var useFollowCam = function useFollowCam(props) {
  var _useThree = useThree(),
    scene = _useThree.scene,
    camera = _useThree.camera;
  var originZDis = props.camInitDis;
  var camMaxDis = props.camMaxDis;
  var camMinDis = props.camMinDis;
  var camCollisionOff = 0.7;
  var pivot = useMemo(function () {
    return new THREE.Object3D();
  }, []);
  var followCam = useMemo(function () {
    var origin = new THREE.Object3D();
    origin.position.set(0, 0, originZDis);
    return origin;
  }, []);
  var smallestDistance = null;
  var cameraDistance = null;
  var intersects = null;
  var intersectObjects = [];
  var cameraRayDir = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var cameraRayOrigin = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var cameraPosition = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var camLerpingPoint = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var camRayCast = new THREE.Raycaster(cameraRayOrigin, cameraRayDir, 0, -camMaxDis);
  var onDocumentMouseMove = function onDocumentMouseMove(e) {
    if (document.pointerLockElement) {
      pivot.rotation.y -= e.movementX * 2e-3;
      var vy = followCam.rotation.x + e.movementY * 2e-3;
      cameraDistance = followCam.position.length();
      if (vy >= -0.5 && vy <= 1.5) {
        followCam.rotation.x = vy;
        followCam.position.y = -cameraDistance * Math.sin(-vy);
        followCam.position.z = -cameraDistance * Math.cos(-vy);
      }
    }
    return false;
  };
  var onDocumentMouseWheel = function onDocumentMouseWheel(e) {
    if (document.pointerLockElement) {
      var vz = originZDis - e.deltaY * 2e-3;
      var vy = followCam.rotation.x + e.movementY * 2e-3;
      if (vz >= camMaxDis && vz <= camMinDis) {
        originZDis = vz;
        followCam.position.z = originZDis * Math.cos(-vy);
        followCam.position.y = originZDis * Math.sin(-vy);
      }
    }
    return false;
  };
  function customTraverse(object) {
    if (object.userData && object.userData.camExcludeCollision === true) {
      return;
    }
    if (object.isMesh && object.geometry.type !== "InstancedBufferGeometry") {
      intersectObjects.push(object);
    }
    object.children.forEach(function (child) {
      customTraverse(child);
    });
  }
  var cameraCollisionDetect = function cameraCollisionDetect(delta) {
    cameraRayOrigin.copy(pivot.position);
    camera.getWorldPosition(cameraPosition);
    cameraRayDir.subVectors(cameraPosition, pivot.position);
    intersects = camRayCast.intersectObjects(intersectObjects);
    if (intersects.length && intersects[0].distance <= -originZDis) {
      smallestDistance = -intersects[0].distance * camCollisionOff < -0.7 ? -intersects[0].distance * camCollisionOff : -0.7;
    } else {
      smallestDistance = originZDis;
    }
    camLerpingPoint.set(followCam.position.x, smallestDistance * Math.sin(-followCam.rotation.x), smallestDistance * Math.cos(-followCam.rotation.x));
    followCam.position.lerp(camLerpingPoint, delta * 4);
  };
  useEffect(function () {
    camera.position.set(0, 0, 0);
  }, []);
  useEffect(function () {
    scene.children.forEach(function (child) {
      return customTraverse(child);
    });
    followCam.add(camera);
    pivot.add(followCam);
    document.addEventListener("mousemove", onDocumentMouseMove);
    document.addEventListener("mousewheel", onDocumentMouseWheel);
    return function () {
      document.removeEventListener("mousemove", onDocumentMouseMove);
      document.removeEventListener("mousewheel", onDocumentMouseWheel);
    };
  });
  return {
    pivot: pivot,
    followCam: followCam,
    cameraCollisionDetect: cameraCollisionDetect
  };
};
var useGame = /* @__PURE__ */create( /* @__PURE__ */subscribeWithSelector(function (set) {
  return {
    /**
     * Character animations state manegement
     */
    // Initial animation
    curAnimation: null,
    animationSet: {},
    initializeAnimationSet: function initializeAnimationSet(animationSet) {
      set(function (state) {
        if (Object.keys(state.animationSet).length === 0) {
          return {
            animationSet: animationSet
          };
        }
        return {};
      });
    },
    reset: function reset() {
      set(function (state) {
        return {
          curAnimation: state.animationSet.idle
        };
      });
    },
    idle: function idle() {
      set(function (state) {
        if (state.curAnimation === state.animationSet.jumpIdle) {
          return {
            curAnimation: state.animationSet.jumpLand
          };
        } else if (state.curAnimation !== state.animationSet.action1 && state.curAnimation !== state.animationSet.action2 && state.curAnimation !== state.animationSet.action3 && state.curAnimation !== state.animationSet.action4) {
          return {
            curAnimation: state.animationSet.idle
          };
        }
        return {};
      });
    },
    walk: function walk() {
      set(function (state) {
        if (state.curAnimation !== state.animationSet.action4) {
          return {
            curAnimation: state.animationSet.walk
          };
        }
        return {};
      });
    },
    run: function run() {
      set(function (state) {
        if (state.curAnimation !== state.animationSet.action4) {
          return {
            curAnimation: state.animationSet.run
          };
        }
        return {};
      });
    },
    jump: function jump() {
      set(function (state) {
        return {
          curAnimation: state.animationSet.jump
        };
      });
    },
    jumpIdle: function jumpIdle() {
      set(function (state) {
        if (state.curAnimation === state.animationSet.jump) {
          return {
            curAnimation: state.animationSet.jumpIdle
          };
        }
        return {};
      });
    },
    jumpLand: function jumpLand() {
      set(function (state) {
        if (state.curAnimation === state.animationSet.jumpIdle) {
          return {
            curAnimation: state.animationSet.jumpLand
          };
        }
        return {};
      });
    },
    fall: function fall() {
      set(function (state) {
        return {
          curAnimation: state.animationSet.fall
        };
      });
    },
    action1: function action1() {
      set(function (state) {
        if (state.curAnimation === state.animationSet.idle) {
          return {
            curAnimation: state.animationSet.action1
          };
        }
        return {};
      });
    },
    action2: function action2() {
      set(function (state) {
        if (state.curAnimation === state.animationSet.idle) {
          return {
            curAnimation: state.animationSet.action2
          };
        }
        return {};
      });
    },
    action3: function action3() {
      set(function (state) {
        if (state.curAnimation === state.animationSet.idle) {
          return {
            curAnimation: state.animationSet.action3
          };
        }
        return {};
      });
    },
    action4: function action4() {
      set(function (state) {
        if (state.curAnimation === state.animationSet.idle || state.curAnimation === state.animationSet.walk || state.curAnimation === state.animationSet.run) {
          return {
            curAnimation: state.animationSet.action4
          };
        }
        return {};
      });
    }
    /**
     * Additional animations
     */
    // triggerFunction: ()=>{
    //    set((state) => {
    //        return { curAnimation: state.animationSet.additionalAnimation };
    //    });
    // }
  };
}));

function EcctrlAnimation(props) {
  var group = useRef();
  var _useGLTF = useGLTF(props.characterURL),
    animations = _useGLTF.animations;
  var _useAnimations = useAnimations(animations, group),
    actions = _useAnimations.actions;
  var curAnimation = useGame(function (state) {
    return state.curAnimation;
  });
  var resetAnimation = useGame(function (state) {
    return state.reset;
  });
  var initializeAnimationSet = useGame(function (state) {
    return state.initializeAnimationSet;
  });
  useEffect(function () {
    initializeAnimationSet(props.animationSet);
  }, []);
  useEffect(function () {
    var action = actions[curAnimation ? curAnimation : props.animationSet.jumpIdle];
    if (curAnimation === props.animationSet.jump || curAnimation === props.animationSet.jumpLand || curAnimation === props.animationSet.action1 || curAnimation === props.animationSet.action2 || curAnimation === props.animationSet.action3 || curAnimation === props.animationSet.action4) {
      action.reset().fadeIn(0.2).setLoop(THREE.LoopOnce, void 0).play();
      action.clampWhenFinished = true;
    } else {
      action.reset().fadeIn(0.2).play();
    }
    action._mixer.addEventListener("finished", function () {
      return resetAnimation();
    });
    return function () {
      action.fadeOut(0.2);
      action._mixer.removeEventListener("finished", function () {
        return resetAnimation();
      });
      action._mixer._listeners = [];
    };
  }, [curAnimation]);
  return /* @__PURE__ */jsx(Suspense, {
    fallback: null,
    children: /* @__PURE__ */jsx("group", {
      ref: group,
      dispose: null,
      userData: {
        camExcludeCollision: true
      },
      children: props.children
    })
  });
}
var Ecctrl = forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$debug = _ref.debug,
    debug = _ref$debug === void 0 ? false : _ref$debug,
    _ref$capsuleHalfHeigh = _ref.capsuleHalfHeight,
    capsuleHalfHeight = _ref$capsuleHalfHeigh === void 0 ? 0.35 : _ref$capsuleHalfHeigh,
    _ref$capsuleRadius = _ref.capsuleRadius,
    capsuleRadius = _ref$capsuleRadius === void 0 ? 0.3 : _ref$capsuleRadius,
    _ref$floatHeight = _ref.floatHeight,
    floatHeight = _ref$floatHeight === void 0 ? 0.3 : _ref$floatHeight,
    _ref$characterInitDir = _ref.characterInitDir,
    characterInitDir = _ref$characterInitDir === void 0 ? 0 : _ref$characterInitDir,
    _ref$followLight = _ref.followLight,
    followLight = _ref$followLight === void 0 ? false : _ref$followLight,
    _ref$camInitDis = _ref.camInitDis,
    camInitDis = _ref$camInitDis === void 0 ? -5 : _ref$camInitDis,
    _ref$camMaxDis = _ref.camMaxDis,
    camMaxDis = _ref$camMaxDis === void 0 ? -7 : _ref$camMaxDis,
    _ref$camMinDis = _ref.camMinDis,
    camMinDis = _ref$camMinDis === void 0 ? -0.7 : _ref$camMinDis,
    _ref$camInitDir = _ref.camInitDir,
    camInitDir = _ref$camInitDir === void 0 ? 0 : _ref$camInitDir,
    _ref$maxVelLimit = _ref.maxVelLimit,
    maxVelLimit = _ref$maxVelLimit === void 0 ? 2.5 : _ref$maxVelLimit,
    _ref$turnVelMultiplie = _ref.turnVelMultiplier,
    turnVelMultiplier = _ref$turnVelMultiplie === void 0 ? 0.2 : _ref$turnVelMultiplie,
    _ref$turnSpeed = _ref.turnSpeed,
    turnSpeed = _ref$turnSpeed === void 0 ? 15 : _ref$turnSpeed,
    _ref$sprintMult = _ref.sprintMult,
    sprintMult = _ref$sprintMult === void 0 ? 2 : _ref$sprintMult,
    _ref$jumpVel = _ref.jumpVel,
    jumpVel = _ref$jumpVel === void 0 ? 4 : _ref$jumpVel,
    _ref$jumpForceToGroun = _ref.jumpForceToGroundMult,
    jumpForceToGroundMult = _ref$jumpForceToGroun === void 0 ? 5 : _ref$jumpForceToGroun,
    _ref$slopJumpMult = _ref.slopJumpMult,
    slopJumpMult = _ref$slopJumpMult === void 0 ? 0.25 : _ref$slopJumpMult,
    _ref$sprintJumpMult = _ref.sprintJumpMult,
    sprintJumpMult = _ref$sprintJumpMult === void 0 ? 1.2 : _ref$sprintJumpMult,
    _ref$airDragMultiplie = _ref.airDragMultiplier,
    airDragMultiplier = _ref$airDragMultiplie === void 0 ? 0.2 : _ref$airDragMultiplie,
    _ref$dragDampingC = _ref.dragDampingC,
    dragDampingC = _ref$dragDampingC === void 0 ? 0.15 : _ref$dragDampingC,
    _ref$accDeltaTime = _ref.accDeltaTime,
    accDeltaTime = _ref$accDeltaTime === void 0 ? 8 : _ref$accDeltaTime,
    _ref$rejectVelMult = _ref.rejectVelMult,
    rejectVelMult = _ref$rejectVelMult === void 0 ? 4 : _ref$rejectVelMult,
    _ref$moveImpulsePoint = _ref.moveImpulsePointY,
    moveImpulsePointY = _ref$moveImpulsePoint === void 0 ? 0.5 : _ref$moveImpulsePoint,
    _ref$camFollowMult = _ref.camFollowMult,
    camFollowMult = _ref$camFollowMult === void 0 ? 11 : _ref$camFollowMult,
    _ref$rayOriginOffest = _ref.rayOriginOffest,
    rayOriginOffest = _ref$rayOriginOffest === void 0 ? {
      x: 0,
      y: -capsuleHalfHeight,
      z: 0
    } : _ref$rayOriginOffest,
    _ref$rayHitForgivenes = _ref.rayHitForgiveness,
    rayHitForgiveness = _ref$rayHitForgivenes === void 0 ? 0.1 : _ref$rayHitForgivenes,
    _ref$rayLength = _ref.rayLength,
    rayLength = _ref$rayLength === void 0 ? capsuleRadius + 2 : _ref$rayLength,
    _ref$rayDir = _ref.rayDir,
    rayDir = _ref$rayDir === void 0 ? {
      x: 0,
      y: -1,
      z: 0
    } : _ref$rayDir,
    _ref$floatingDis = _ref.floatingDis,
    floatingDis = _ref$floatingDis === void 0 ? capsuleRadius + floatHeight : _ref$floatingDis,
    _ref$springK = _ref.springK,
    springK = _ref$springK === void 0 ? 1.2 : _ref$springK,
    _ref$dampingC = _ref.dampingC,
    dampingC = _ref$dampingC === void 0 ? 0.08 : _ref$dampingC,
    _ref$showSlopeRayOrig = _ref.showSlopeRayOrigin,
    showSlopeRayOrigin = _ref$showSlopeRayOrig === void 0 ? false : _ref$showSlopeRayOrig,
    _ref$slopeMaxAngle = _ref.slopeMaxAngle,
    slopeMaxAngle = _ref$slopeMaxAngle === void 0 ? 1 : _ref$slopeMaxAngle,
    _ref$slopeRayOriginOf = _ref.slopeRayOriginOffest,
    slopeRayOriginOffest = _ref$slopeRayOriginOf === void 0 ? capsuleRadius - 0.03 : _ref$slopeRayOriginOf,
    _ref$slopeRayLength = _ref.slopeRayLength,
    slopeRayLength = _ref$slopeRayLength === void 0 ? capsuleRadius + 3 : _ref$slopeRayLength,
    _ref$slopeRayDir = _ref.slopeRayDir,
    slopeRayDir = _ref$slopeRayDir === void 0 ? {
      x: 0,
      y: -1,
      z: 0
    } : _ref$slopeRayDir,
    _ref$slopeUpExtraForc = _ref.slopeUpExtraForce,
    slopeUpExtraForce = _ref$slopeUpExtraForc === void 0 ? 0.1 : _ref$slopeUpExtraForc,
    _ref$slopeDownExtraFo = _ref.slopeDownExtraForce,
    slopeDownExtraForce = _ref$slopeDownExtraFo === void 0 ? 0.2 : _ref$slopeDownExtraFo,
    _ref$autoBalance = _ref.autoBalance,
    autoBalance = _ref$autoBalance === void 0 ? true : _ref$autoBalance,
    _ref$autoBalanceSprin = _ref.autoBalanceSpringK,
    autoBalanceSpringK = _ref$autoBalanceSprin === void 0 ? 0.3 : _ref$autoBalanceSprin,
    _ref$autoBalanceDampi = _ref.autoBalanceDampingC,
    autoBalanceDampingC = _ref$autoBalanceDampi === void 0 ? 0.03 : _ref$autoBalanceDampi,
    _ref$autoBalanceSprin2 = _ref.autoBalanceSpringOnY,
    autoBalanceSpringOnY = _ref$autoBalanceSprin2 === void 0 ? 0.3 : _ref$autoBalanceSprin2,
    _ref$autoBalanceDampi2 = _ref.autoBalanceDampingOnY,
    autoBalanceDampingOnY = _ref$autoBalanceDampi2 === void 0 ? 0.02 : _ref$autoBalanceDampi2,
    _ref$animated = _ref.animated,
    animated = _ref$animated === void 0 ? false : _ref$animated,
    props = _objectWithoutProperties(_ref, _excluded);
  var characterRef = ref || useRef();
  var characterModelRef = useRef();
  var modelFacingVec = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var bodyFacingVec = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var bodyBalanceVec = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var bodyBalanceVecOnX = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var bodyFacingVecOnY = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var bodyBalanceVecOnZ = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var vectorY = useMemo(function () {
    return new THREE.Vector3(0, 1, 0);
  }, []);
  var vectorZ = useMemo(function () {
    return new THREE.Vector3(0, 0, 1);
  }, []);
  var idleAnimation = !animated ? null : useGame(function (state) {
    return state.idle;
  });
  var walkAnimation = !animated ? null : useGame(function (state) {
    return state.walk;
  });
  var runAnimation = !animated ? null : useGame(function (state) {
    return state.run;
  });
  var jumpAnimation = !animated ? null : useGame(function (state) {
    return state.jump;
  });
  var jumpIdleAnimation = !animated ? null : useGame(function (state) {
    return state.jumpIdle;
  });
  !animated ? null : useGame(function (state) {
    return state.jumpLand;
  });
  var fallAnimation = !animated ? null : useGame(function (state) {
    return state.fall;
  });
  var action1Animation = !animated ? null : useGame(function (state) {
    return state.action1;
  });
  var action2Animation = !animated ? null : useGame(function (state) {
    return state.action2;
  });
  var action3Animation = !animated ? null : useGame(function (state) {
    return state.action3;
  });
  var action4Animation = !animated ? null : useGame(function (state) {
    return state.action4;
  });
  var characterControlsDebug = null;
  var floatingRayDebug = null;
  var slopeRayDebug = null;
  var autoBalanceForceDebug = null;
  if (debug) {
    characterControlsDebug = useControls("Character Controls", {
      maxVelLimit: {
        value: maxVelLimit,
        min: 0,
        max: 10,
        step: 0.01
      },
      turnVelMultiplier: {
        value: turnVelMultiplier,
        min: 0,
        max: 1,
        step: 0.01
      },
      turnSpeed: {
        value: turnSpeed,
        min: 5,
        max: 30,
        step: 0.1
      },
      sprintMult: {
        value: sprintMult,
        min: 1,
        max: 5,
        step: 0.01
      },
      jumpVel: {
        value: jumpVel,
        min: 0,
        max: 10,
        step: 0.01
      },
      jumpForceToGroundMult: {
        value: jumpForceToGroundMult,
        min: 0,
        max: 80,
        step: 0.1
      },
      slopJumpMult: {
        value: slopJumpMult,
        min: 0,
        max: 1,
        step: 0.01
      },
      sprintJumpMult: {
        value: sprintJumpMult,
        min: 1,
        max: 3,
        step: 0.01
      },
      airDragMultiplier: {
        value: airDragMultiplier,
        min: 0,
        max: 1,
        step: 0.01
      },
      dragDampingC: {
        value: dragDampingC,
        min: 0,
        max: 0.5,
        step: 0.01
      },
      accDeltaTime: {
        value: accDeltaTime,
        min: 0,
        max: 50,
        step: 1
      },
      rejectVelMult: {
        value: rejectVelMult,
        min: 0,
        max: 10,
        step: 0.1
      },
      moveImpulsePointY: {
        value: moveImpulsePointY,
        min: 0,
        max: 3,
        step: 0.1
      },
      camFollowMult: {
        value: camFollowMult,
        min: 0,
        max: 15,
        step: 0.1
      }
    }, {
      collapsed: true
    });
    maxVelLimit = characterControlsDebug.maxVelLimit;
    turnVelMultiplier = characterControlsDebug.turnVelMultiplier;
    turnSpeed = characterControlsDebug.turnSpeed;
    sprintMult = characterControlsDebug.sprintMult;
    jumpVel = characterControlsDebug.jumpVel;
    jumpForceToGroundMult = characterControlsDebug.jumpForceToGroundMult;
    slopJumpMult = characterControlsDebug.slopJumpMult;
    sprintJumpMult = characterControlsDebug.sprintJumpMult;
    airDragMultiplier = characterControlsDebug.airDragMultiplier;
    dragDampingC = characterControlsDebug.dragDampingC;
    accDeltaTime = characterControlsDebug.accDeltaTime;
    rejectVelMult = characterControlsDebug.rejectVelMult;
    moveImpulsePointY = characterControlsDebug.moveImpulsePointY;
    camFollowMult = characterControlsDebug.camFollowMult;
    floatingRayDebug = useControls("Floating Ray", {
      rayOriginOffest: {
        x: 0,
        y: -capsuleHalfHeight,
        z: 0
      },
      rayHitForgiveness: {
        value: rayHitForgiveness,
        min: 0,
        max: 0.5,
        step: 0.01
      },
      rayLength: {
        value: capsuleRadius + 2,
        min: 0,
        max: capsuleRadius + 10,
        step: 0.01
      },
      rayDir: {
        x: 0,
        y: -1,
        z: 0
      },
      floatingDis: {
        value: capsuleRadius + floatHeight,
        min: 0,
        max: capsuleRadius + 2,
        step: 0.01
      },
      springK: {
        value: springK,
        min: 0,
        max: 5,
        step: 0.01
      },
      dampingC: {
        value: dampingC,
        min: 0,
        max: 3,
        step: 0.01
      }
    }, {
      collapsed: true
    });
    rayOriginOffest = floatingRayDebug.rayOriginOffest;
    rayHitForgiveness = floatingRayDebug.rayHitForgiveness;
    rayLength = floatingRayDebug.rayLength;
    rayDir = floatingRayDebug.rayDir;
    floatingDis = floatingRayDebug.floatingDis;
    springK = floatingRayDebug.springK;
    dampingC = floatingRayDebug.dampingC;
    slopeRayDebug = useControls("Slope Ray", {
      showSlopeRayOrigin: false,
      slopeMaxAngle: {
        value: slopeMaxAngle,
        min: 0,
        max: 1.57,
        step: 0.01
      },
      slopeRayOriginOffest: {
        value: capsuleRadius,
        min: 0,
        max: capsuleRadius + 3,
        step: 0.01
      },
      slopeRayLength: {
        value: capsuleRadius + 3,
        min: 0,
        max: capsuleRadius + 13,
        step: 0.01
      },
      slopeRayDir: {
        x: 0,
        y: -1,
        z: 0
      },
      slopeUpExtraForce: {
        value: slopeUpExtraForce,
        min: 0,
        max: 5,
        step: 0.01
      },
      slopeDownExtraForce: {
        value: slopeDownExtraForce,
        min: 0,
        max: 5,
        step: 0.01
      }
    }, {
      collapsed: true
    });
    showSlopeRayOrigin = slopeRayDebug.showSlopeRayOrigin;
    slopeMaxAngle = slopeRayDebug.slopeMaxAngle;
    slopeRayLength = slopeRayDebug.slopeRayLength;
    slopeRayDir = slopeRayDebug.slopeRayDir;
    slopeUpExtraForce = slopeRayDebug.slopeUpExtraForce;
    slopeDownExtraForce = slopeRayDebug.slopeDownExtraForce;
    autoBalanceForceDebug = useControls("AutoBalance Force", {
      autoBalance: {
        value: true
      },
      autoBalanceSpringK: {
        value: autoBalanceSpringK,
        min: 0,
        max: 5,
        step: 0.01
      },
      autoBalanceDampingC: {
        value: autoBalanceDampingC,
        min: 0,
        max: 0.1,
        step: 1e-3
      },
      autoBalanceSpringOnY: {
        value: autoBalanceSpringOnY,
        min: 0,
        max: 5,
        step: 0.01
      },
      autoBalanceDampingOnY: {
        value: autoBalanceDampingOnY,
        min: 0,
        max: 0.1,
        step: 1e-3
      }
    }, {
      collapsed: true
    });
    autoBalance = autoBalanceForceDebug.autoBalance;
    autoBalanceSpringK = autoBalanceForceDebug.autoBalanceSpringK;
    autoBalanceDampingC = autoBalanceForceDebug.autoBalanceDampingC;
    autoBalanceSpringOnY = autoBalanceForceDebug.autoBalanceSpringOnY;
    autoBalanceDampingOnY = autoBalanceForceDebug.autoBalanceDampingOnY;
  }
  var _useKeyboardControls = useKeyboardControls(),
    _useKeyboardControls2 = _slicedToArray(_useKeyboardControls, 2),
    subscribeKeys = _useKeyboardControls2[0],
    getKeys = _useKeyboardControls2[1];
  var _useRapier = useRapier(),
    rapier = _useRapier.rapier,
    world = _useRapier.world;
  var canJump = false;
  var isOnMovingObject = false;
  var standingForcePoint = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var movingObjectDragForce = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var movingObjectVelocity = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var movingObjectVelocityInCharacterDir = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var distanceFromCharacterToObject = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var objectAngvelToLinvel = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var dirLight = null;
  var cameraSetups = {
    camInitDis: camInitDis,
    camMaxDis: camMaxDis,
    camMinDis: camMinDis
  };
  var _useFollowCam = useFollowCam(cameraSetups),
    pivot = _useFollowCam.pivot,
    followCam = _useFollowCam.followCam,
    cameraCollisionDetect = _useFollowCam.cameraCollisionDetect;
  var pivotPosition = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var modelEuler = useMemo(function () {
    return new THREE.Euler();
  }, []);
  var modelQuat = useMemo(function () {
    return new THREE.Quaternion();
  }, []);
  var moveImpulse = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var movingDirection = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var moveAccNeeded = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var jumpVelocityVec = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var jumpDirection = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var currentVel = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var currentPos = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var dragForce = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var dragAngForce = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var wantToMoveVel = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var rejectVel = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var floatingForce = null;
  var springDirVec = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var characterMassForce = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var rayOrigin = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var rayCast = new rapier.Ray(rayOrigin, rayDir);
  var rayHit = null;
  var slopeAngle = null;
  var actualSlopeNormal = null;
  var actualSlopeAngle = null;
  var actualSlopeNormalVec = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var floorNormal = useMemo(function () {
    return new THREE.Vector3(0, 1, 0);
  }, []);
  var slopeRayOriginRef = useRef();
  var slopeRayorigin = useMemo(function () {
    return new THREE.Vector3();
  }, []);
  var slopeRayCast = new rapier.Ray(slopeRayorigin, slopeRayDir);
  var slopeRayHit = null;
  var moveCharacter = function moveCharacter(_, run, slopeAngle2, movingObjectVelocity2) {
    if (actualSlopeAngle < slopeMaxAngle && Math.abs(slopeAngle2) > 0.2 && Math.abs(slopeAngle2) < slopeMaxAngle) {
      movingDirection.set(0, Math.sin(slopeAngle2), Math.cos(slopeAngle2));
    } else if (actualSlopeAngle >= slopeMaxAngle) {
      movingDirection.set(0, Math.sin(slopeAngle2) > 0 ? 0 : Math.sin(slopeAngle2), Math.sin(slopeAngle2) > 0 ? 0.1 : 1);
    } else {
      movingDirection.set(0, 0, 1);
    }
    movingDirection.applyQuaternion(characterModelRef.current.quaternion);
    movingObjectVelocityInCharacterDir.copy(movingObjectVelocity2).projectOnVector(movingDirection).multiply(movingDirection);
    var angleBetweenCharacterDirAndObjectDir = movingObjectVelocity2.angleTo(movingDirection);
    var wantToMoveMeg = currentVel.dot(movingDirection);
    wantToMoveVel.set(movingDirection.x * wantToMoveMeg, 0, movingDirection.z * wantToMoveMeg);
    rejectVel.copy(currentVel).sub(wantToMoveVel);
    moveAccNeeded.set((movingDirection.x * (maxVelLimit * (run ? sprintMult : 1) + movingObjectVelocityInCharacterDir.x) - (currentVel.x - movingObjectVelocity2.x * Math.sin(angleBetweenCharacterDirAndObjectDir) + rejectVel.x * (isOnMovingObject ? 0 : rejectVelMult))) / accDeltaTime, 0, (movingDirection.z * (maxVelLimit * (run ? sprintMult : 1) + movingObjectVelocityInCharacterDir.z) - (currentVel.z - movingObjectVelocity2.z * Math.sin(angleBetweenCharacterDirAndObjectDir) + rejectVel.z * (isOnMovingObject ? 0 : rejectVelMult))) / accDeltaTime);
    var moveForceNeeded = moveAccNeeded.multiplyScalar(characterRef.current.mass());
    var characterRotated = Math.sin(characterModelRef.current.rotation.y).toFixed(3) == Math.sin(modelEuler.y).toFixed(3);
    if (!characterRotated) {
      moveImpulse.set(moveForceNeeded.x * turnVelMultiplier * (canJump ? 1 : airDragMultiplier),
      // if it's in the air, give it less control
      slopeAngle2 === null || slopeAngle2 == 0 ? 0 : movingDirection.y * turnVelMultiplier * (movingDirection.y > 0 ? slopeUpExtraForce : slopeDownExtraForce) * (run ? sprintMult : 1), moveForceNeeded.z * turnVelMultiplier * (canJump ? 1 : airDragMultiplier)
      // if it's in the air, give it less control
      );
    } else {
      moveImpulse.set(moveForceNeeded.x * (canJump ? 1 : airDragMultiplier), slopeAngle2 === null || slopeAngle2 == 0 ? 0 : movingDirection.y * (movingDirection.y > 0 ? slopeUpExtraForce : slopeDownExtraForce) * (run ? sprintMult : 1), moveForceNeeded.z * (canJump ? 1 : airDragMultiplier));
    }
    characterRef.current.applyImpulseAtPoint(moveImpulse, {
      x: currentPos.x,
      y: currentPos.y + moveImpulsePointY,
      z: currentPos.z
    }, false);
  };
  var autoBalanceCharacter = function autoBalanceCharacter() {
    bodyFacingVec.set(0, 0, 1).applyQuaternion(quat(characterRef.current.rotation()));
    bodyBalanceVec.set(0, 1, 0).applyQuaternion(quat(characterRef.current.rotation()));
    bodyBalanceVecOnX.set(0, bodyBalanceVec.y, bodyBalanceVec.z);
    bodyFacingVecOnY.set(bodyFacingVec.x, 0, bodyFacingVec.z);
    bodyBalanceVecOnZ.set(bodyBalanceVec.x, bodyBalanceVec.y, 0);
    characterModelRef.current.getWorldDirection(modelFacingVec);
    var crossVecOnX = vectorY.clone().cross(bodyBalanceVecOnX);
    var crossVecOnY = vectorZ.clone().cross(bodyFacingVecOnY);
    var crossVecOnZ = vectorY.clone().cross(bodyBalanceVecOnZ);
    dragAngForce.set((crossVecOnX.x < 0 ? 1 : -1) * autoBalanceSpringK * bodyBalanceVecOnX.angleTo(vectorY) - characterRef.current.angvel().x * autoBalanceDampingC, (crossVecOnY.y < 0 ? 1 : -1) * autoBalanceSpringOnY * bodyFacingVecOnY.angleTo(vectorZ) - characterRef.current.angvel().y * autoBalanceDampingOnY, (crossVecOnZ.z < 0 ? 1 : -1) * autoBalanceSpringK * bodyBalanceVecOnZ.angleTo(vectorY) - characterRef.current.angvel().z * autoBalanceDampingC);
    characterRef.current.applyTorqueImpulse(dragAngForce, false);
  };
  useEffect(function () {
    if (followLight) {
      dirLight = characterModelRef.current.parent.parent.children.find(function (item) {
        return item.name === "followLight";
      });
    }
    var unSubscribeAction1 = subscribeKeys(function (state) {
      return state.action1;
    }, function (value) {
      if (value) {
        animated && action1Animation();
      }
    });
    var unSubscribeAction2 = subscribeKeys(function (state) {
      return state.action2;
    }, function (value) {
      if (value) {
        animated && action2Animation();
      }
    });
    var unSubscribeAction3 = subscribeKeys(function (state) {
      return state.action3;
    }, function (value) {
      if (value) {
        animated && action3Animation();
      }
    });
    var unSubscribeAction4 = subscribeKeys(function (state) {
      return state.action4;
    }, function (value) {
      if (value) {
        animated && action4Animation();
      }
    });
    return function () {
      unSubscribeAction1();
      unSubscribeAction2();
      unSubscribeAction3();
      unSubscribeAction4();
    };
  });
  useEffect(function () {
    characterRef.current.setEnabledRotations(autoBalance ? true : false, autoBalance ? true : false, autoBalance ? true : false, false);
  }, [autoBalance]);
  useEffect(function () {
    modelEuler.y = characterInitDir;
    pivot.rotation.y = camInitDir;
  }, []);
  useFrame(function (state, delta) {
    var _a, _b, _c;
    if (characterRef.current) {
      currentPos.copy(characterRef.current.translation());
    }
    if (followLight && dirLight) {
      dirLight.position.x = currentPos.x + 20;
      dirLight.position.y = currentPos.y + 30;
      dirLight.position.z = currentPos.z + 10;
      dirLight.target = characterModelRef.current;
    }
    var _getKeys = getKeys(),
      forward = _getKeys.forward,
      backward = _getKeys.backward,
      leftward = _getKeys.leftward,
      rightward = _getKeys.rightward,
      jump = _getKeys.jump,
      run = _getKeys.run;
    if (forward) {
      modelEuler.y = pivot.rotation.y;
    } else if (backward) {
      modelEuler.y = pivot.rotation.y + Math.PI;
    } else if (leftward) {
      modelEuler.y = pivot.rotation.y + Math.PI / 2;
    } else if (rightward) {
      modelEuler.y = pivot.rotation.y - Math.PI / 2;
    }
    if (forward && leftward) {
      modelEuler.y = pivot.rotation.y + Math.PI / 4;
    } else if (forward && rightward) {
      modelEuler.y = pivot.rotation.y - Math.PI / 4;
    } else if (backward && leftward) {
      modelEuler.y = pivot.rotation.y - Math.PI / 4 + Math.PI;
    } else if (backward && rightward) {
      modelEuler.y = pivot.rotation.y + Math.PI / 4 + Math.PI;
    }
    if (forward || backward || leftward || rightward) moveCharacter(delta, run, slopeAngle, movingObjectVelocity);
    if (characterRef.current) {
      currentVel.copy(characterRef.current.linvel());
    }
    if (jump && canJump) {
      jumpVelocityVec.set(currentVel.x, run ? sprintJumpMult * jumpVel : jumpVel, currentVel.z);
      characterRef.current.setLinvel(jumpDirection.set(0, (run ? sprintJumpMult * jumpVel : jumpVel) * slopJumpMult, 0).projectOnVector(actualSlopeNormalVec).add(jumpVelocityVec), false);
      characterMassForce.y *= jumpForceToGroundMult;
      (_a = rayHit.collider.parent()) == null ? void 0 : _a.applyImpulseAtPoint(characterMassForce, standingForcePoint, true);
    }
    modelQuat.setFromEuler(modelEuler);
    characterModelRef.current.quaternion.rotateTowards(modelQuat, delta * turnSpeed);
    pivotPosition.set(currentPos.x, currentPos.y + (capsuleHalfHeight + capsuleRadius / 2), currentPos.z);
    pivot.position.lerp(pivotPosition, 1 - Math.exp(-camFollowMult * delta));
    state.camera.lookAt(pivot.position);
    rayOrigin.addVectors(currentPos, rayOriginOffest);
    rayHit = world.castRay(rayCast, rayLength, true, null, null,
    // I have no idea
    characterRef.current, null,
    // this exclude with sensor collider
    function (collider) {
      return !collider.isSensor();
    });
    if (rayHit && rayHit.toi < floatingDis + rayHitForgiveness) {
      if (slopeRayHit && actualSlopeAngle < slopeMaxAngle) {
        canJump = true;
      }
    } else {
      canJump = false;
    }
    if (rayHit && canJump) {
      if (rayHit.collider.parent()) {
        standingForcePoint.set(rayOrigin.x, rayOrigin.y - rayHit.toi, rayOrigin.z);
        var rayHitObjectBodyType = rayHit.collider.parent().bodyType();
        var rayHitObjectBodyMass = rayHit.collider.parent().mass();
        if ((rayHitObjectBodyType === 0 || rayHitObjectBodyType === 2) && rayHitObjectBodyMass > 0.5) {
          isOnMovingObject = true;
          distanceFromCharacterToObject.copy(currentPos).sub(rayHit.collider.parent().translation());
          var movingObjectLinvel = rayHit.collider.parent().linvel();
          var movingObjectAngvel = rayHit.collider.parent().angvel();
          movingObjectVelocity.set(movingObjectLinvel.x + objectAngvelToLinvel.crossVectors(movingObjectAngvel, distanceFromCharacterToObject).x, movingObjectLinvel.y, movingObjectLinvel.z + objectAngvelToLinvel.crossVectors(movingObjectAngvel, distanceFromCharacterToObject).z);
          if (rayHitObjectBodyType === 0) {
            if (!forward && !backward && !leftward && !rightward && canJump) {
              movingObjectDragForce.set((currentVel.x - movingObjectVelocity.x) * dragDampingC, 0, (currentVel.z - movingObjectVelocity.z) * dragDampingC);
            } else {
              movingObjectDragForce.copy(moveImpulse).negate();
            }
            rayHit.collider.parent().applyImpulseAtPoint(movingObjectDragForce, standingForcePoint, true);
          }
        } else {
          isOnMovingObject = false;
          movingObjectVelocity.set(0, 0, 0);
        }
      }
    }
    slopeRayOriginRef.current.getWorldPosition(slopeRayorigin);
    slopeRayorigin.y = rayOrigin.y;
    slopeRayHit = world.castRay(slopeRayCast, slopeRayLength, true, null, null,
    // Still no idea
    characterRef.current, null,
    // this exclude with sensor collider
    function (collider) {
      return !collider.isSensor();
    });
    if (slopeRayHit) {
      actualSlopeNormal = (_b = slopeRayHit.collider.castRayAndGetNormal(slopeRayCast, slopeRayLength, false)) == null ? void 0 : _b.normal;
      if (actualSlopeNormal) {
        actualSlopeNormalVec == null ? void 0 : actualSlopeNormalVec.set(actualSlopeNormal.x, actualSlopeNormal.y, actualSlopeNormal.z);
        actualSlopeAngle = actualSlopeNormalVec == null ? void 0 : actualSlopeNormalVec.angleTo(floorNormal);
      }
    }
    if (slopeRayHit && rayHit && slopeRayHit.toi < floatingDis + 0.5) {
      if (canJump) {
        slopeAngle = Number(Math.atan((rayHit.toi - slopeRayHit.toi) / slopeRayOriginOffest).toFixed(2));
      } else {
        slopeAngle = null;
      }
    } else {
      slopeAngle = null;
    }
    if (rayHit != null) {
      if (canJump && rayHit.collider.parent()) {
        floatingForce = springK * (floatingDis - rayHit.toi) - characterRef.current.linvel().y * dampingC;
        characterRef.current.applyImpulse(springDirVec.set(0, floatingForce, 0), false);
        characterMassForce.set(0, floatingForce > 0 ? -floatingForce : 0, 0);
        (_c = rayHit.collider.parent()) == null ? void 0 : _c.applyImpulseAtPoint(characterMassForce, standingForcePoint, true);
      }
    }
    if (!forward && !backward && !leftward && !rightward && canJump) {
      if (!isOnMovingObject) {
        dragForce.set(-currentVel.x * dragDampingC, 0, -currentVel.z * dragDampingC);
        characterRef.current.applyImpulse(dragForce, false);
      } else {
        dragForce.set((movingObjectVelocity.x - currentVel.x) * dragDampingC * 2, 0, (movingObjectVelocity.z - currentVel.z) * dragDampingC * 2);
        characterRef.current.applyImpulse(dragForce, false);
      }
    }
    if (autoBalance && characterRef.current) {
      autoBalanceCharacter();
    }
    cameraCollisionDetect(delta);
    if (animated) {
      if (!forward && !backward && !leftward && !rightward && !jump && canJump) {
        idleAnimation();
      } else if (jump && canJump) {
        jumpAnimation();
      } else if (canJump && (forward || backward || leftward || rightward)) {
        run ? runAnimation() : walkAnimation();
      } else if (!canJump) {
        jumpIdleAnimation();
      }
      if (rayHit == null && currentVel.y < 0) {
        fallAnimation();
      }
    }
  });
  return /* @__PURE__ */jsxs(RigidBody, _objectSpread(_objectSpread({
    colliders: false,
    canSleep: false,
    ref: characterRef,
    position: props.position || [0, 5, 0],
    friction: props.friction || -0.5
  }, props), {}, {
    children: [/* @__PURE__ */jsx(CapsuleCollider, {
      args: [capsuleHalfHeight, capsuleRadius]
    }), /* @__PURE__ */jsxs("group", {
      ref: characterModelRef,
      userData: {
        camExcludeCollision: true
      },
      children: [/* @__PURE__ */jsx("mesh", {
        position: [rayOriginOffest.x, rayOriginOffest.y, rayOriginOffest.z + slopeRayOriginOffest],
        ref: slopeRayOriginRef,
        visible: showSlopeRayOrigin,
        userData: {
          camExcludeCollision: true
        },
        children: /* @__PURE__ */jsx("boxGeometry", {
          args: [0.15, 0.15, 0.15]
        })
      }), children]
    })]
  }));
});
export { EcctrlAnimation, Ecctrl as default };